import { Button } from '../../../../components/Button';
import { MdLink, MdDescription, MdAdd, MdLinkOff, MdPlaylistAdd } from 'react-icons/md';

interface Props {
  selectedCount: number;
  /** 一括アクション処理中フラグ。処理中は全ボタンを無効化する */
  isProcessing?: boolean;
  /** PDF生成の進捗。生成中はPDF共有ボタンのラベルに表示する */
  pdfProgress?: { current: number; total: number } | null;
  onDeselectAll: () => void;
  onWebShare?: () => void;
  onPdfShare?: () => void;
  onSuggestToCandidates?: () => void;
  onAddToList?: () => void;
}

export default function SelectionBar({
  selectedCount,
  isProcessing,
  pdfProgress,
  onDeselectAll,
  onWebShare,
  onPdfShare,
  onSuggestToCandidates,
  onAddToList,
}: Props) {
  if (selectedCount === 0) return null;

  return (
    <div className="sticky bottom-0 z-50 flex items-center justify-between gap-2 rounded-t bg-white px-6 py-4 shadow-layer3">
      {/* 左側: 選択件数 */}
      <div className="flex items-baseline gap-1">
        <span className="text-lg font-bold">{selectedCount}件</span>
        <span className="mr-1 text-sm">選択中</span>
        {/* 処理中の選択解除でバー自体が消えて進捗表示が失われるのを防ぐため、解除ボタンも無効化する */}
        <Button color="secondary" size="md" onClick={onDeselectAll} disabled={isProcessing}>
          <MdLinkOff className="size-icon-xs" />
          選択解除
        </Button>
      </div>

      {/* 右側: アクションボタン */}
      <div className="flex items-center gap-2">
        {onAddToList && (
          <Button color="secondary" size="md" onClick={onAddToList} disabled={isProcessing}>
            <MdPlaylistAdd className="size-icon-xs" />
            リストに追加
          </Button>
        )}
        {onWebShare && (
          <Button color="secondary" size="md" onClick={onWebShare} disabled={isProcessing}>
            <MdLink className="size-icon-xs" />
            WEB共有
          </Button>
        )}
        {onPdfShare && (
          <Button color="secondary" size="md" onClick={onPdfShare} disabled={isProcessing}>
            <MdDescription className="size-icon-xs" />
            {pdfProgress ? `PDF作成中 (${pdfProgress.current}/${pdfProgress.total})` : 'PDF共有'}
          </Button>
        )}
        {onSuggestToCandidates && (
          <Button
            color="secondary"
            size="md"
            onClick={onSuggestToCandidates}
            disabled={isProcessing}
          >
            <MdAdd className="size-icon-xs" />
            求職者に提案
          </Button>
        )}
      </div>
    </div>
  );
}
